{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Je hebt de gesprekslimiet overschreden. Het Hacker-abonnement staat slechts 500 gesprekken toe.",
      "INBOXES": "Je hebt de inboxlimiet overschreden. Het Hacker-abonnement ondersteunt alleen live chat op de website. Extra inboxen zoals e-mail, WhatsApp enz. vereisen een betaald abonnement.",
      "AGENTS": "Je hebt de agentlimiet overschreden. Het Hacker-abonnement staat slechts 2 agenten toe.",
      "NON_ADMIN": "Neem contact op met je beheerder om het abonnement te upgraden en alle functies te blijven gebruiken."
    },
    "TITLE": "Accountinstellingen",
    "SUBMIT": "Instellingen bijwerken",
    "BACK": "Terug",
    "DISMISS": "Negeer",
    "UPDATE": {
      "ERROR": "Instellingen konden niet worden bijgewerkt, probeer het opnieuw!",
      "SUCCESS": "Accountinstellingen succesvol bijgewerkt"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Verwijder je account",
      "NOTE": "Zodra je je account verwijdert, worden al je gegevens verwijderd.",
      "BUTTON_TEXT": "Verwijder je account",
      "CONFIRM": {
        "TITLE": "Account verwijderen",
        "MESSAGE": "Het verwijderen van je account kan niet ongedaan worden gemaakt. Voer hieronder je accountnaam in om te bevestigen dat je het permanent wilt verwijderen.",
        "BUTTON_TEXT": "Verwijderen",
        "DISMISS": "Annuleren",
        "PLACE_HOLDER": "Typ {accountName} om te bevestigen"
      },
      "SUCCESS": "Account gemarkeerd voor verwijdering",
      "FAILURE": "Kan het account niet verwijderen, probeer het opnieuw!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Dit account staat gepland voor verwijdering op {deletionDate}. Dit is aangevraagd door een beheerder. Je kunt de verwijdering vóór deze datum annuleren.",
        "MESSAGE_INACTIVITY": "Dit account staat gepland voor verwijdering op {deletionDate} vanwege inactiviteit. Je kunt de verwijdering vóór deze datum annuleren.",
        "CLEAR_BUTTON": "Geplande verwijdering annuleren"
      }
    },
    "FORM": {
      "ERROR": "Corrigeer formulierfouten",
      "GENERAL_SECTION": {
        "TITLE": "Algemene instellingen",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "accountnaam",
        "PLACEHOLDER": "Uw accountnaam",
        "ERROR": "Voer een geldige accountnaam in"
      },
      "LANGUAGE": {
        "LABEL": "Taal",
        "PLACEHOLDER": "Uw accountnaam",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "The domain where you will receive the emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mailadres support",
        "PLACEHOLDER": "E-mailadres support van uw bedrijf",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Number of days after a ticket should auto resolve if there is no activity",
        "NOTE": "Aantal uren inactiviteit waarna een open gesprek automatisch wordt opgelost.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Aantal dagen waarna een leeg gesprek automatisch wordt opgelost als er geen activiteit is",
        "PLACEHOLDER": "nooit",
        "ERROR": "Voer een geldige duur in voor automatisch oplossen van lege gesprekken (minimaal 1 dag en maximaal 999 dagen)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Conversation continuity with emails is enabled for your account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "You can receive emails in your custom domain now."
      },
      "PHONE": {
        "TITLE": "PBX-instellingen",
        "NOTE": "Configureer de verbinding met je PBX voor telefoongesprekken",
        "SIP_HOST": {
          "LABEL": "SIP-domein"
        },
        "DIALING_MODE": {
          "LABEL": "Belmodus",
          "MODES": {
            "direct": "Direct - het gesprek wordt meteen gebeld bij het klikken op de telefoonlink",
            "indirect": "Indirect - het telefoonnummer wordt klaargezet in het invoerveld van de telefoonwidget"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Toegang tot gespreksopnamen",
          "MODES": {
            "admin_only": "Alleen beheerders",
            "admin_and_assigned_agent": "Beheerders en de toegewezen agent",
            "inbox_members": "Alle agenten met toegang tot de inbox"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-mailinstellingen",
        "NOTE": "Wijzigt het gedrag van e-mailinboxen"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Weergavemodus voor gesprekstijdstempel",
        "MODES": {
          "both": "Aangemaakt en laatste activiteit",
          "last_activity_only": "Alleen laatste activiteit",
          "last_customer_message": "Laatste bericht van klant"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Domeinen met een lage reputatie blokkeren"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Oorspronkelijk bericht opnemen in antwoord op de e-mail"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Nieuw gesprek automatisch oplossen"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Een nieuw e-mailgesprek automatisch verplaatsen naar de inbox van de robot die de bestellingen van het contact heeft verwerkt"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Uitgebreide labels - Sta langere labelnamen toe met een grotere pop-upinterface"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Wijs het gesprek automatisch toe aan de agent die het laatste antwoord gaf"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Modus voor pushmeldingen",
        "MODES": {
          "all_inboxes": "Alle inboxen - Stuur meldingen voor alle kanaaltypen",
          "chat_only": "Alleen chat - Stuur alleen meldingen voor kanalen die geen e-mail zijn"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Sta het in- en uitschakelen van de handtekening bij verzonden berichten toe"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Toon chatstatus van agenten op het wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Toon volledige bestandsnamen van bijlagen zonder afkorting"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Inloggen met wachtwoord",
        "MODES": {
          "allowed_for_all": "Toegestaan voor alle gebruikers",
          "allowed_for_agents_only": "Alleen toegestaan voor agenten (beheerders moeten OAuth gebruiken)",
          "password_login_disabled": "Uitgeschakeld - alleen OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Er is een nieuwe versie beschikbaar. Herlaad de pagina voor de laatste updates.",
    "RELOAD_NOW": "Nu bijwerken",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Je betaling is in behandeling. Werk je betaalgegevens bij om deze software te blijven gebruiken",
    "LIMITS_UPGRADE": "Je account heeft de gebruikslimieten overschreden. Upgrade je abonnement om deze software te blijven gebruiken",
    "OPEN_BILLING": "Openstaande facturering"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Press enter to select",
      "ENTER_TO_REMOVE": "Press enter to remove",
      "NO_OPTIONS": "Lijst is leeg",
      "NO_RESULT": "Geen resultaten gevonden",
      "SELECT_ONE": "Selecteer een",
      "SELECT": "Selecteer"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "verwijderd",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "Geen meldingen",
      "TABLE_HEADER": [
        "Naam",
        "Telefoonnummer",
        "Gesprekken",
        "Laatste contact"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "New conversation",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "Nieuw bericht",
      "participating_conversation_new_message": "Nieuw bericht",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Verbinding verbroken",
      "DESCRIPTION": "We konden de server niet bereiken. Controleer je verbinding en probeer het opnieuw.",
      "RETRY": "Opnieuw proberen"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "Algemeen",
      "REPORTS": "Rapporten",
      "CONVERSATION": "Gesprek",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Demp gesprek",
      "EXECUTE_MACRO": "Macro uitvoeren",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Instellingen",
      "AI_ASSIST": "AI-assistent",
      "APPEARANCE": "Weergave",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI-assistent",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Een macro uitvoeren",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Demp gesprek",
      "UNTIL_NEXT_REPLY": "Tot de volgende reactie",
      "UNTIL_NEXT_WEEK": "Tot volgende week",
      "UNTIL_TOMORROW": "Tot morgen",
      "UNTIL_NEXT_MONTH": "Tot volgende maand",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "Systeem",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "klik hier"
  }
}
